export default __webpack_public_path__ + "static/media/select-gift-friend-plan.e9994e31.jpg";